import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getPartners,
  getPartnerById,
  createPartner,
  updatePartner,
  removePartner,
} from "../repositories/partnerRepository";
import { appendJsonPart } from "../utilities/formDataUtils";

// Partner API multipart kutadi: "data" — application/json Blob,
// "logo" — bitta fayl, "gallery" — har biri alohida append qilingan fayllar.
const buildPartnerFormData = ({ data, logo, gallery }) => {
  const formData = new FormData();

  appendJsonPart(formData, "data", data);

  if (logo) {
    formData.append("logo", logo);
  }

  gallery?.forEach((file) => formData.append("gallery", file));

  return formData;
};

export default {
  getPartners: async ({ currentPage, pageSize }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    return await getPartners({
      "current-page": pageNumber,
      "page-size": itemsPerPage,
    });
  },

  getPartnerById: async (id) => await getPartnerById(id),

  createPartner: async (payload) =>
    await createPartner(buildPartnerFormData(payload)),

  updatePartner: async (id, payload) =>
    await updatePartner(id, buildPartnerFormData(payload)),

  removePartner: async (id) => await removePartner(id),
};
